import { render } from "./TransitionWrapper.vue?vue&type=template&id=1785a6a2&scoped=true&ts=true"
import script from "./TransitionWrapper.vue?vue&type=script&lang=ts"
export * from "./TransitionWrapper.vue?vue&type=script&lang=ts"

import "./TransitionWrapper.vue?vue&type=style&index=0&id=1785a6a2&scoped=true&lang=scss"

import exportComponent from "/Users/matejvehar/git/mvehar/pi-slidoos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1785a6a2"]])

export default __exports__